import { DevsiteEnvModel } from 'shared/models/env';

const envFromScript = document.getElementById('env')?.innerText;
const DevsiteEnv: DevsiteEnvModel = envFromScript && JSON.parse(envFromScript);

export default DevsiteEnv;
